import CryptoJS from "crypto-js";
import { STORES } from "../config/stores";
import { getDeveloperRegion } from "./developerRegion";

const GEO_KEY = "g_v1";
const GEO_TTL = 24 * 60 * 60 * 1000; // 24 hours
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

const FALLBACK = {
  country: "Egypt",
  countryCode: "EG",
  storeId: 1,
  currency: "EGP",
  currencyName: "Egyptian Pound",
};

/** Encrypt object to string */
function encrypt(data) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
}

/** Decrypt string to object */
function decrypt(cipher) {
  try {
    const bytes = CryptoJS.AES.decrypt(cipher, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch {
    return null;
  }
}

/** Fetch user's IP info from ipapi.co */
async function fetchIpInfo() {
  const res = await fetch("https://ipapi.co/json/");
  if (!res.ok) throw new Error("Geo lookup failed");
  return res.json();
}

/** Returns geo object with fallback logic */
export async function fetchUserGeo() {
  const override = getDeveloperRegion();
  if (override) return { ...override, timestamp: Date.now() };

  try {
    // Read encrypted cache first
    const cachedRaw = localStorage.getItem(GEO_KEY);
    if (cachedRaw) {
      const cached = decrypt(cachedRaw);
      if (
        cached &&
        cached.timestamp &&
        Date.now() - cached.timestamp < GEO_TTL
      ) {
        return cached;
      }
    }

    // Fetch fresh IP info
    const data = await fetchIpInfo();
    const code = data.country_code?.toUpperCase() || "EG";

    let geo;

    if (code === "AE") {
      // UAE
      geo = {
        ...STORES[3],
        storeId: 3,
        timestamp: Date.now(),
      };
    } else if (code === "SA") {
      // Saudi Arabia
      geo = {
        ...STORES[4],
        storeId: 4,
        timestamp: Date.now(),
      };
    } else if (code === "NL") {
      // TESTING ONLY Netherlands
      geo = {
        ...STORES[2],
        storeId: 2,
        timestamp: Date.now(),
      };
    } else {
      // Default to Egypt for everything else
      geo = {
        ...FALLBACK,
        timestamp: Date.now(),
      };
    }

    localStorage.setItem(GEO_KEY, encrypt(geo));
    return geo;
  } catch (err) {
    // On failure, fallback to Egypt
    const fallback = { ...FALLBACK, timestamp: Date.now() };
    localStorage.setItem(GEO_KEY, encrypt(fallback));
    return fallback;
  }
}

/** Clear cached geo */
export function clearCachedGeo() {
  localStorage.removeItem(GEO_KEY);
}
